import { useState } from 'react';
import Unit from '../../../../types/Unit/Unit';
import SelectUnit from '../../../../components/SelectUnit/SelectUnit';
import { convertToUnit } from '../../../../hooks/useFactionData/useFactionData.util';
import { Button, FormLabel, Offcanvas } from 'react-bootstrap';
import useAttackEvaluation from '../../../../hooks/useAttackEvaluation/useAttackEvaluation';
import AttackBonuses, { AttackBonusDetails, defaultAttackBonusDetails } from '../../Damage/AttackBonuses/AttackBonuses';

interface FaceOffDisplayProps {
  unit: Unit;
}

function FaceOffDisplay({ unit }: FaceOffDisplayProps) {
  const [attackBonusDetails, setAttackBonusDetails] = useState<AttackBonusDetails>({ ...defaultAttackBonusDetails });
  const [targetAttackBonusDetails, setTargetAttackBonusDetails] = useState<AttackBonusDetails>({ ...defaultAttackBonusDetails });

  const [showOptions, setShowOptions] = useState(false);
  const [showTargetOptions, setShowTargetOptions] = useState(false);

  const [targetUnit, setTargetUnit] = useState<Unit | undefined>();

  const { averageDamage: unitAverage} = useAttackEvaluation({
    unit,
    ...attackBonusDetails,
    save: targetUnit?.save ?? '6+',
    ward: targetUnit?.wardType ?? '6+',
    isEthereal: false,
    didCharge: false
  });

  const { averageDamage: targetAverage } = useAttackEvaluation({
    unit: targetUnit ?? new Unit(),
    ...targetAttackBonusDetails,
    save: unit?.save ?? '6+',
    ward: unit?.wardType ?? '6+',
    isEthereal: false,
    didCharge: false
  });

  return (
    <div>
      <Button onClick={() => setShowOptions(!showOptions)}>Options</Button>
      <Button variant="danger" onClick={() => setAttackBonusDetails({ ...defaultAttackBonusDetails })}>Reset</Button>
      <br/>
      <FormLabel>Target</FormLabel>
      <SelectUnit
        onUnitSelected={(unit) => {
          setTargetUnit(convertToUnit(unit));
        }}
      />
      <Button onClick={() => setShowTargetOptions(!showOptions)}>Target Options</Button>
      <Button variant="danger" onClick={() => setTargetAttackBonusDetails({ ...defaultAttackBonusDetails })}>Reset</Button>
      <br/>
      {unitAverage.toFixed(2)}
      <br/>
      {targetAverage.toFixed(2)}
      <Offcanvas 
        style={{ height: 'calc(100vh - 100px)', padding: '5%', overflow: 'auto' }} 
        show={showOptions} 
        onHide={() => setShowOptions(false)} 
        placement="bottom"
      >
        <Offcanvas.Body>
          <AttackBonuses attackBonusDetails={attackBonusDetails} onAttackBonusChange={setAttackBonusDetails}/>
          <Button onClick={() => setShowOptions(false)}>Done</Button>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas 
        style={{ height: 'calc(100vh - 100px)', padding: '5%', overflow: 'auto' }} 
        show={showTargetOptions} 
        onHide={() => setShowTargetOptions(false)} 
        placement="bottom"
      >
        <Offcanvas.Body>
          <AttackBonuses attackBonusDetails={targetAttackBonusDetails} onAttackBonusChange={setTargetAttackBonusDetails}/>
          <Button onClick={() => setShowTargetOptions(false)}>Done</Button>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
}

export default FaceOffDisplay;